export default {
  'fields': [
    {
      'name': 'hashtag',
      'format': '',
      'type': 'string'
    },
    {
      'name': 'day',
      'format': 'YYYY-M-D H:m:s',
      'type': 'timestamp'
    },
    {
      'name': 'latitude',
      'format': '',
      'type': 'real'
    },
    {
      'name': 'longitude',
      'format': '',
      'type': 'real'
    }
  ],
  'rows': [
    ['#kecelakaan', '2020-03-21 00:00:00 -0400', -8.796749, 115.227747],
    ['#kecelakaan', '2020-03-21 00:00:00 -0400', -8.798446, 115.223026],
    ['#kecelakaan', '2020-03-21 00:00:00 -0400', -8.802135, 115.228734],
    ['#macet', '2020-03-22 00:00:00 -0400', -8.790727, 115.212812],
    ['#macet', '2020-03-22 00:00:00 -0400', -8.785170, 115.197706],
    ['#kecelakaan', '2020-03-22 00:00:00 -0400', -8.769997, 115.199582],
    ['#penjagaan', '2020-03-22 00:00:00 -0400', -8.793366, 115.215718],
    ['#penjagaan', '2020-03-23 00:00:00 -0400', -8.782042, 115.178767],
    ['#patroli', '2020-03-23 00:00:00 -0400', -8.743779, 115.175068],
    ['#pencurian', '2020-03-23 00:00:00 -0400', -8.729300, 115.168363],
    ['#pencurian', '2020-03-24 00:00:00 -0400', -8.718628, 115.198101],
    ['#patroli', '2020-03-24 00:00:00 -0400', -8.700988, 115.163506]
  ]
}